import { render } from "./EngineeringDesign.vue?vue&type=template&id=5d3a6c62&scoped=true"
import script from "./EngineeringDesign.vue?vue&type=script&lang=js"
export * from "./EngineeringDesign.vue?vue&type=script&lang=js"

import "./EngineeringDesign.vue?vue&type=style&index=0&id=5d3a6c62&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3a6c62"]])

export default __exports__